var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"q10__jumbotron flex flex-col md:flex-row"},[_c('image-with-descriptions',{staticStyle:{"margin":"0","margin-bottom":"1.25rem"},attrs:{"options":{
                image2:
                    'pages/' +
                    _vm.currentPage.slug +
                    '/' +
                    _vm.currentPage.images.oImage1.src,
                descriptions: [
                    {
                        text: _vm.currentPage.images.oImage1.alt,
                        position: 'bottom-right', // top/bottom-left/right
                        orientation: 'horizontal', // vertical, horizontal
                    },
                     {
                        text: _vm.currentPage.images.oImage1.text,
                        position: 'bottom-left', // top/bottom-left/right
                        orientation: 'horizontal', // vertical, horizontal
                    } ],
            }}}),_c('image-with-descriptions',{staticStyle:{"margin":"0","margin-bottom":"1.25rem"},attrs:{"options":{
                        image:
                            'pages/' +
                            _vm.currentPage.slug +
                            '/' +
                            _vm.currentPage.images.oImage2.src,
                        descriptions: [
                            {
                                text: _vm.currentPage.images.oImage2.alt,
                                position: 'bottom-right', // top/bottom-left/right
                                orientation: 'horizontal', // vertical, horizontal
                            },
                            {
                                text: _vm.currentPage.images.oImage2.text,
                                position: 'bottom-left', // top/bottom-left/right
                                orientation: 'horizontal', // vertical, horizontal
                            } ],
                    }}})],1),_c('div',{staticClass:"page"},[_c('div',{staticClass:"container px-11 2xl:px-3 mb-14 m-auto"},[_c('title-s-chapter',{attrs:{"options":{
                    from: 'from-allports',
                    to: 'to-resolution_blue',
                }}},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sArticleTitle.text)}})]),_c('div',{staticClass:"container-components"},[_c('div',{staticClass:"card relative",staticStyle:{"margin-bottom":"0"}},[_c('div',{staticClass:"\n                            q10__article_container__content__paragraphs\n                            relative\n                        "},[_vm._l((_vm.currentPage
                                .content.sParagraphOne_Content_01.text),function(paragraph,idx_paragraph){return [(idx_paragraph === 0)?[_c('paragraph-first-letter-big',{staticStyle:{"margin-left":"0"},attrs:{"options":{
                                        letter: paragraph.substr(0, 1),
                                        color: 'text-allports',
                                    }}}),_c('paragraph',{staticClass:"inline",attrs:{"options":{}}},[_c('span',{staticClass:"text-nandor inline",domProps:{"innerHTML":_vm._s(paragraph.slice(1))}})]),_c('router-link',{attrs:{"to":{
                                        name: 'catalogue',
                                        params: { slug: 'page-026' },
                                    }},domProps:{"innerHTML":_vm._s(
                                        _vm.currentPage.content
                                            .sParagraphOne_Content_03.text
                                    )}}),_c('span',{staticClass:"text-base md:text-lg",domProps:{"innerHTML":_vm._s(
                                        _vm.currentPage.content
                                            .sParagraphOne_Content_02.text
                                    )}})]:_vm._e()]})],2)])]),_c('TitleParagraph',{attrs:{"options":{
                    from: 'from-allports',
                    to: 'to-resolution_blue',
                }}},[_c('p',{staticClass:"text-2xl lg:text-4xl 2xl:text-7xl mt-12",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sSubTitleOne.text)}})]),_c('div',{staticClass:"container-components"},[_c('div',{staticClass:"card break-inside-avoid mt-0 pt-0"},[_c('div',{staticClass:"relative pt-10"},[_c('hotspot-richmedia',{staticClass:"top-0 md:-top-2 right-2",attrs:{"options":{
                                icon: 'diaporama',
                                collection: _vm.getRichmediaByCollection(
                                    _vm.currentPage,
                                    'Conduites forcées : de l’innovation dans les tuyaux'
                                ),
                            }}})],1),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphTwo_Content
                                    .text
                            )}})])],1),_c('div',{staticClass:"relative"},[_c('image-with-descriptions',{attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.oImage3.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.oImage3.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    } ],
                            }}}),_c('hotspot-richmedia',{staticClass:"top-2 right-2",attrs:{"options":{
                    icon: "diaporama",
                    collection:  [
                                    {
                                        "src": _vm.getSpecificURL() + "fr/richmedia/page-029/alea_112_01_pragneres.mp4",
                                        "type": "html5video",
                                        "caption": "Chantier de Pragnères",
                                        "thumb": _vm.getSpecificURL() + "fr/images/thumbs/faire_face_aux_aleas_techniques/resized_pragniers.jpg",
                                    },
                                    {
                                        "src": _vm.getSpecificURL() + "fr/richmedia/page-029/amoa_83_master_pradieres_decryptage_dune_success_story_st.mp4",
                                        "type": "html5video",
                                        "caption": "Remplacement de la conduite forcée à Pradières (2019-2021)",
                                        "thumb": _vm.getSpecificURL() + "fr/images/thumbs/faire_face_aux_aleas_techniques/3_2_equipe_de_choc_pour_story.jpg"
                                    }
                                ] 
                            }}})],1)])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }